import * as React from 'react';

import { SwipeableDrawer, Modal, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import InputContainer from './InputContainer';
import type { ITheme } from '../../../theme';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()((theme: ITheme) => ({
  modal: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      padding: '0 1em',
    },
  },
  content: {
    overflowY: 'auto',
    overflowX: 'clip',
    padding: '1em',
    width: '100%',
    maxHeight: '100vh',
  },
  drawer: {
    width: '100%',
    position: 'relative',
  },
  puller: {
    width: 60,
    height: 6,
    backgroundColor: '#ffffff65',
    left: 'calc(50% - 30px)',
    borderRadius: 3,
    position: 'absolute',
    top: 8,
    margin: 'auto auto',
    zIndex: 1,
  },
}));

export interface InputContainerModalProps {
  handleClose?: () => void;
  modalAsDrawer?: boolean;
}

const InputContainerModal: React.FC<InputContainerModalProps> = ({
  handleClose,
  modalAsDrawer,
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <>
      {!isMobile && (
        <Modal open onClose={handleClose} className={classes.modal}>
          <div className={classes.content}>
            <InputContainer
              title={t('home.songbook.input_button')}
              subtitle={''}
              handleCloseModal={handleClose}
            />
          </div>
        </Modal>
      )}
      {isMobile && modalAsDrawer && (
        <div>
          <SwipeableDrawer
            anchor="bottom"
            open
            onClose={handleClose}
            className={classes.drawer}
            onOpen={() => {}}>
            <div className={classes.puller} />
            <div className={classes.content}>
              <InputContainer
                title={t('home.songbook.input_button')}
                subtitle={''}
                asDrawer
                handleCloseModal={handleClose}
              />
            </div>
          </SwipeableDrawer>
        </div>
      )}
    </>
  );
};

export default InputContainerModal;
